import React from 'react'
import '../Css/spinner.css'

const Spinner = () => {
  return <div className="loader" />
}

export default Spinner
